import { toast } from "sonner";
import { api, track, USER_ID } from "./api";

const KEY = "xp_picks";
const PENDING = "xp_picks_pending";
const TOAST_STYLE = { background: "#1A1A1A", color: "#D4AF37", border: "1px solid rgba(212,175,55,0.4)" };

export const getPicks = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

export const picksPending = () => localStorage.getItem(PENDING) === "1";

const syncServer = (p) =>
  api.post("/picks/sync", {
    user_id: USER_ID,
    table: localStorage.getItem("xp_table") || "",
    items: p.map(({ slug, name, price, qty }) => ({ slug, name, price, qty })),
  }).then((r) => {
    (r.data?.new_stamps || []).forEach((s) =>
      toast.success(`${s.name.toUpperCase()} EXPLORER stamp earned — check your Passport!`, { style: TOAST_STYLE }));
    if (r.data?.stamp_bonus?.awarded)
      toast.success(`PASSPORT COMPLETE — +${r.data.stamp_bonus.points} bonus points!`, { style: TOAST_STYLE });
    if (picksPending()) {
      localStorage.removeItem(PENDING);
      window.dispatchEvent(new Event("xp-picks-pending"));
      toast.success("Order list synced — you're back online", { style: TOAST_STYLE });
    }
  }).catch(() => {
    localStorage.setItem(PENDING, "1");
    window.dispatchEvent(new Event("xp-picks-pending"));
  });

export const resyncPicks = () => {
  if (picksPending()) syncServer(getPicks());
};

const save = (p) => {
  localStorage.setItem(KEY, JSON.stringify(p));
  window.dispatchEvent(new Event("xp-picks-changed"));
  syncServer(p);
};

export const addPick = (dish, qty = 1, silent = false) => {
  if (dish?.available === false) {
    toast.error(`${dish.name} is unavailable right now — ask your server`, { style: TOAST_STYLE });
    return;
  }
  const picks = getPicks();
  const found = picks.find((p) => p.slug === dish.slug);
  if (found) found.qty += qty;
  else picks.push({ slug: dish.slug, name: dish.name, price: dish.price, image: dish.image, vegetarian: dish.vegetarian, brand: dish.brand, qty });
  save(picks);
  track("pick_added", { slug: dish.slug });
  window.dispatchEvent(new CustomEvent("xp-mascot", { detail: { type: "dish-added", name: dish.name } }));
  if (!silent) {
    const lang = localStorage.getItem("xp_lang") || "en";
    const suffix = lang === "hi" ? "ऑर्डर लिस्ट में जुड़ गया" : lang === "pa" ? "ਆਰਡਰ ਲਿਸਟ ਵਿੱਚ ਜੁੜ ਗਿਆ" : "added to your order list";
    toast.success(`${dish.name} ${suffix}`, { style: TOAST_STYLE });
  }
};

export const setPickQty = (slug, qty) => {
  let picks = getPicks();
  if (qty <= 0) picks = picks.filter((p) => p.slug !== slug);
  else picks = picks.map((p) => (p.slug === slug ? { ...p, qty } : p));
  save(picks);
};

export const clearPicks = () => {
  save([]);
  track("picks_cleared", {});
};

export const picksCount = () => getPicks().reduce((s, p) => s + p.qty, 0);

export const pickListToast = (label = "Added to your order list") => toast.success(label, { style: TOAST_STYLE });
